import { combineReducers } from 'redux';

import groupSetupReducer from './groupsetup/reducer';
import dataDictionaryReducer from './datadictionary/reducer';
import sourceConfigurationReducer from './sourceconfiguration/reducer';
import refGqlReducer from './refdataexplorer/reducer';
import blocDataExplorerReducer from './blocdataexplorer/reducer';
import RefDataMatchingRuleReducer from './refdatamatchingrules/reducer';
import dataImportsReducer from './dataImports/reducer';
import refDatareportConfigurationReducer from './refdatareportconfiguration/reducer';
import groupConfigurationReducer from './groupconfiguration/reducer';
import groupFilterReducer from './groupfilter/reducer';
import reportSchedulersReducer from './reportschedulers/reducer';
import usersReducer from '../users/reducer';
import enrichmentReducer from './dataenrichments/reducer';
import eventConfigurationReducer from './eventconfiguration/reducer';
import RefDataviewsReducer from './viewexplorer/reducer';
import RefDataDefaultConfigurationReducer from './refdatadefaultconfiguration/reducer';
import validationConfigurationReducer from './validationconfiguration/reducer';
import purgeReducer from './datapurge/reducer';
import importSetupReducer from './importsetup/reducer';

const refDataReducer = combineReducers({
    groupSetupReducer,
    dataDictionaryReducer,
    sourceConfigurationReducer,
    refGqlReducer,
    blocDataExplorerReducer,
    RefDataMatchingRuleReducer,
    dataImportsReducer,
    reportSchedulersReducer,
    refDatareportConfigurationReducer,
    groupConfigurationReducer,
    groupFilterReducer,
    usersReducer,
    enrichmentReducer,
    eventConfigurationReducer,
    RefDataviewsReducer,
    RefDataDefaultConfigurationReducer,
    validationConfigurationReducer,
    purgeReducer,
    importSetupReducer,
});

export default refDataReducer;
